import ChalkySticks from '@chalkysticks/sdk';
import { ActionContext } from 'vuex';
import { IStoreState } from './State';

/**
 * @type ActionContext<S, R>
 */
type Context = ActionContext<IStoreState, IStoreState>;

/**
 * Actions are generally meant to be the entrypoint for modifying state.
 *
 * They are asynchronous calls that can perform other tasks and then
 * trigger a mutation (synchronous).
 *
 * @see https://vuex.vuejs.org/guide/actions.html
 *
 * @class Actions
 * @package Store
 * @project ChalkySticks Pad
 */
const actions = {
	/**
	 * @param Context context
	 * @return void
	 */
	isBallMode(context: Context): void {
		context.commit('setDiagramState', ChalkySticks.Pad.Enum.DiagramState.BallMode);
	},

	/**
	 * @param Context context
	 * @return void
	 */
	isBallSelectionMode(context: Context): void {
		context.commit('setDiagramState', ChalkySticks.Pad.Enum.DiagramState.BallSelect);
	},

	/**
	 * @param Context context
	 * @return void
	 */
	setLineMode(context: Context): void {
		context.commit('setDiagramState', ChalkySticks.Pad.Enum.DiagramState.LineMode);
	},
};

export default actions;
